export enum PignorState {
  Active = 1,
  Disabled = 2,
}
